import { Box, Card, Flex, Stack, Text } from '@mantine/core'
import React from 'react'
import ImageFallback from './image_fallback'
import { getText } from '../utils/constants'

const SeasonsCard = ({
  seasonNumber,
  premiereDate,
  episodeQty,
  synopsis,
  imgSrc,
  title
}) => {
  const t = (key) => getText('SeasonsCard', key)

  const isValidDate = premiereDate instanceof Date && !isNaN(premiereDate)
  const isValidEpisodes = typeof episodeQty === 'number' && episodeQty > 0
  const hasSynopsis = typeof synopsis === 'string' && synopsis.trim().length > 0
  const normalizeSeasonNumber = (seasonNumber) => {
    return seasonNumber?.toUpperCase().includes('SEASON')
      ? seasonNumber.replace(/SEASON/i, '').trim() // Eliminar 'SEASON'
      : seasonNumber
  }

  return (
    <Box
      h={230}
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Card
        radius={4}
        sx={{
          backgroundColor: '#0E1922',
          borderBottom: '2px solid #7B39B6',
          overflow: 'visible'
        }}
        h={200}
        w={555}
      >
        <Flex
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%'
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -30,
              width: '130px',
              height: '194px',
              borderRadius: '2px',
              overflow: 'hidden'
            }}
          >
            <ImageFallback
              src={imgSrc}
              fallbackSrc="/noimage.png"
              alt={t('noSynopsis')}
              style={{ objectFit: 'cover' }}
            />
          </Box>
          <Stack p={12} spacing={0} ml={130}>
            {seasonNumber && (
              <Text size={12} tt="uppercase" color="white">
                {title} {t('season')} {normalizeSeasonNumber(seasonNumber)}
              </Text>
            )}
            {isValidDate && isValidEpisodes && (
              <Text size={12} fw="bolder" color="primary">
                {premiereDate.getFullYear()} | {episodeQty} {t('episodes')} |{' '}
                {t('premieredOn')}{' '}
                {premiereDate.toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </Text>
            )}
            <Text size={12} c="dimmed">
              {hasSynopsis ? synopsis : t('noSynopsis')}
            </Text>
          </Stack>
        </Flex>
      </Card>
    </Box>
  )
}

export default SeasonsCard
